import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Image from '../../atoms/Image/Image';

const navList = [
  {
    name: 'BoB is',
    id: 0,
    innerNav: [
      { id: 0, name: 'Message', src: '/introduce/message' },
      { id: 1, name: 'History', src: '/introduce/history' },
      { id: 2, name: 'BoB Center Introduce', src: '/introduce/bci' },
      { id: 3, name: 'BI Introduce', src: '/introduce/bi' },
      { id: 4, name: 'Visit way', src: '/introduce/visit' },
    ],
  },
  {
    name: 'Education',
    id: 1,
    innerNav: [
      { id: 0, name: 'Education Process Plan', src: '/education/process' },
      { id: 1, name: 'Track Introduce', src: '/education/track' },
      { id: 2, name: 'Trainee Benefits', src: '/education/trainee' },
    ],
  },
  {
    name: 'Footprints',
    id: 2,
    innerNav: [
      { id: 0, name: 'Achievements', src: '/footprint/achievement' },
      { id: 1, name: 'Edu Sketch', src: '/footprint/edu' },
      { id: 2, name: 'Video', src: '/footprint/video' },
      { id: 3, name: 'MOU', src: '/footprint/mou' },
      { id: 4, name: 'Press Release', src: '/footprint/release' },
    ],
  },
  {
    name: 'Notice',
    id: 3,
    innerNav: [
      { id: 0, name: 'Notice', src: '/notice/list' },
      { id: 1, name: 'Brochure', src: '/notice/brochure' },
    ],
  },
];

export default function Header() {
  const { pathname } = useLocation();

  const useStyles = makeStyles((theme) => ({
    r: {
      width: '100vw',
      zIndex: 10,
      position: 'fixed',
      top: '0',
      backgroundColor: pathname === '/' ? 'none' : 'white',
      '@media only screen and (max-width: 768px)': {
        display: 'none',
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '1280px',
      width: '100%',
      margin: '0 auto',
    },
    topNav: {
      display: 'flex',
      height: '100px',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    icon: {
      height: '68px',
      margin: '0 32px',
      cursor: 'pointer',
    },
    navBox: {
      display: 'flex',
    },
    nav: {
      fontSize: '20px',
      lineHeight: '24px',
      color: pathname === '/' ? theme.color.white : theme.color.black,
      margin: '0 16px',
      cursor: 'pointer',
    },
    kor: {
      color: pathname === '/' ? theme.color.white : theme.color.black,
      display: 'flex',
      fontSize: '16px',
      lineHeight: '20px',
      margin: '0 32px',
      cursor: 'pointer',
    },
    bottomNav: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    bottonInner: {
      width: 'fit-content',
      position: 'relative',
    },
    indiBox: {
      display: 'flex',
      position: 'absolute',
    },
    indi: {
      height: '2px',
      backgroundColor: pathname === '/' ? '#ffffff50' : '#00000050',
      left: 0,
      zIndex: -1,
    },
    bNavList: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    bNav: {
      padding: '18px 0px 20px 0px',
      margin: '0 16px',
      fontSize: '16px',
      lineHeight: '20px',
      color: pathname === '/' ? theme.color.white : theme.color.black,
      cursor: 'pointer',
      borderTop: '2px solid #00000000',
    },
  }));

  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [hovered, setHovered] = useState([]);
  const [selectedNav, setSelectedNav] = useState({});

  const navigate = useNavigate();

  const mouseEnter = (n) => {
    const indi = document.querySelector('#indi');
    indi.style.transition = 'none';
    indi.style.width = 0;
    setHovered(n.innerNav);
  };
  const mouseLeave = () => {
    setHovered([]);
    const indi = document.querySelector('#indi');
    indi.style.transition = 'none';
    indi.style.width = 0;
    indi.style.marginLeft = 0;
  };

  const handleOnClick = (a, n) => {
    setHovered([]);
    setSelected(a);
    setSelectedNav(n);

    navigate(n.src);
  };

  const handleHome = () => {
    setHovered([]);
    setSelected([]);
    setSelectedNav({});
    const indi = document.querySelector('#indi');
    indi.style.transition = 'none';
    indi.style.width = 0;
    indi.style.marginLeft = 0;

    navigate('/');
  };

  const handleIndi = (id) => {
    // const left = document.querySelector(`#${id}`).offsetLeft;
    // const width = document.querySelector(`#${id}`).offsetWidth;
    // const indi = document.querySelector('#indi');
    // indi.style.transition = 'all .5s';
    // indi.style.width = `${width}px`;
    // indi.style.marginLeft = `${left}px`;
  };

  const handleKor = () => {
    //kor 링크
    window.location.href = 'https://www.kitribob.kr/';
  };

  useEffect(() => {
    if (pathname === '/') return;

    if (selected.length !== 0 || !!selectedNav.id) return;
    for (const nl of navList) {
      for (const n of nl.innerNav) {
        if (n.src === pathname) {
          setSelectedNav(n);
          setSelected(nl.innerNav);
        }
      }
    }
  }, [pathname, selected.length, selectedNav.id]);

  const handleNavClick = (n) => {
    setSelected(n.innerNav);
    setSelectedNav(n.innerNav[0]);
    navigate(n.innerNav[0].src);
  };

  return (
    <Box className={classes.r}>
      <Box id='root' onMouseLeave={mouseLeave} className={classes.root}>
        <Box className={classes.topNav}>
          <Image onClick={handleHome} className={classes.icon} src={pathname === '/' ? '../../images/logo_wh@2x.png' : '../../images/logo_bl@2x.png'} alt='header icon' />
          <Box className={classes.navBox}>
            {navList.map((n, i) => {
              return (
                <Box
                  onMouseEnter={mouseEnter.bind(this, n)}
                  onClick={handleNavClick.bind(this, n)}
                  className={classes.nav}
                  key={i}
                  style={selected === n.innerNav ? { fontWeight: 'bold' } : {}}
                >
                  {n.name}
                </Box>
              );
            })}
          </Box>
          <Box onClick={handleKor} className={classes.kor}>
            KOR
          </Box>
        </Box>

        <Box className={classes.bottomNav}>
          <Box className={classes.bottonInner}>
            <Box className={classes.indiBox}>
              <span id={'indi'} className={classes.indi} />
            </Box>
            <Box className={classes.bNavList}>
              {hovered.length !== 0
                ? hovered.map((h, i) => {
                    return (
                      <Box
                        key={i}
                        id={`bNav_${h.id}`}
                        onMouseEnter={handleIndi.bind(this, `bNav_${h.id}`)}
                        onClick={handleOnClick.bind(this, hovered, h)}
                        className={classes.bNav}
                        style={selectedNav === h ? { borderColor: '#191919' } : {}}
                      >
                        {h.name}
                      </Box>
                    );
                  })
                : selected.map((s, i) => {
                    return (
                      <Box
                        key={i}
                        id={`bNav_${s.id}`}
                        onMouseEnter={handleIndi.bind(this, `bNav_${s.id}`)}
                        onClick={handleOnClick.bind(this, selected, s)}
                        className={classes.bNav}
                        style={selectedNav === s ? { borderColor: '#191919' } : {}}
                      >
                        {s.name}
                      </Box>
                    );
                  })}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
